






















































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import { IProduct, PolicyFilterDto, PolicyStatus } from 'admiral-core';
import PolicyStatusProgress from '@/views/pages/policies/PolicyStatusProgress.vue';

interface Result {
  quantity: number;
  value: number;
  // @ts-ignore
  [key: PolicyStatus]: {
    quantity: number;
    value: number;
  };
}

@Component({
  name: 'policy-product-card',
  components: { PolicyStatusProgress },
})
export default class PolicyProductCard extends mixins(FilterMixin) {
  @Prop({ type: Object })
  product!: IProduct;
  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  @Prop({
    required: true,
    type: Object,
    default: () => {
      return {
        [PolicyStatus.PLANNED]: {
          value: 0,
          quantity: 0,
        },
        [PolicyStatus.OPEN]: {
          value: 0,
          quantity: 0,
        },
        [PolicyStatus.SUBMITTED]: {
          value: 0,
          quantity: 0,
        },
        [PolicyStatus.POLICED]: {
          value: 0,
          quantity: 0,
        },
        [PolicyStatus.DECLINED]: {
          value: 0,
          quantity: 0,
        },
        [PolicyStatus.CANCELED]: {
          value: 0,
          quantity: 0,
        },
        ['OPEN70']: {
          value: 0,
          quantity: 0,
        },
        value: 0,
        quantity: 0,
      };
    },
  })
  result!: Result;

  get policyFilter(): PolicyFilterDto {
    return this.$store.getters[`PreferencesModule/getPolicyFilter`];
  }

  get inactive() {
    if (this.readonly) {
      return false;
    }
    return (
      // @ts-ignore
      this.policyFilter.products.length > 0 && !this.policyFilter.products.includes(this.product)
    );
  }

  get active() {
    if (this.readonly) {
      return false;
    }
    return (
      // @ts-ignore
      this.policyFilter.products.length > 0 && this.policyFilter.products.includes(this.product)
    );
  }

  onCardClick() {
    if (!this.readonly) {
      this.handleSelect();
    }
  }

  async handleSelect() {
    let products: IProduct[] = [];
    // @ts-ignore

    if (!this.policyFilter.products.includes(this.product)) {
      products = [this.product];
    }

    await this.$store.dispatch('PreferencesModule/setPolicyFilter', {
      ...this.policyFilter,
      products,
    });
    // this.$root.$emit('update-policy-filter');
  }
}
